import type { Submission } from "@workshop-survey/shared";

export type AdminResponse = {
  id: number;
  submissionId: string;
  participant: string;
  startedAt: string;
  submittedAt: string;
  durationMs: number;
  motivation: string | null;
  aiExperience: string | null;
  operatingSystem: string | null;
  userAgent: string | null;
  createdAt: string;
  answers: Submission["answers"];
};

export type ApiError = {
  status: number;
  body: unknown;
};

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });
  const text = await res.text();
  const body: unknown = text ? safeParse(text) : null;
  if (!res.ok) {
    const err: ApiError = { status: res.status, body };
    throw err;
  }
  return body as T;
}

function safeParse(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export const api = {
  health: () => request<{ status: string; db: string }>("/api/health"),

  submitResponse: (submission: Submission) =>
    request<{ id: number; deduplicated?: boolean }>("/api/responses", {
      method: "POST",
      body: JSON.stringify(submission),
    }),

  adminListResponses: () =>
    request<{ responses: AdminResponse[] }>("/api/admin/responses"),
};
